/**
 * <ScrollView> — la zone qui défile du design system (atome, L0.1) : celui de React Native, mêmes props et
 * même `ref`, qui porte au web la barre du DS (`utils/webScrollbars`) ; rien ne change sur le natif.
 * Le principe et la règle du lint : `design-system/CLAUDE.md`, « Une zone qui défile ».
 */
import React, { forwardRef } from "react"
import { ScrollView as RNScrollView, type ScrollViewProps as RNScrollViewProps } from "react-native"

import { dsScrollProps } from "../../utils/webScrollbars"

// `dataSet` est une prop de react-native-web, absente des types de React Native.
export type ScrollViewProps = RNScrollViewProps & { dataSet?: Record<string, string> }

/** L'instance qu'on tient par `ref` : celle de React Native (`useRef<ScrollView>(null)`). */
export type ScrollView = RNScrollView

export const ScrollView = forwardRef<RNScrollView, ScrollViewProps>(function ScrollView(props, ref) {
    return <RNScrollView ref={ref} {...props} {...dsScrollProps(props.dataSet)} />
})
